import { Schema } from "effect";
import { Pagination } from "../utils/pagination";
export class Model extends Schema.Class("superwall-api-User-Model")({
    object: Schema.Literal("user"),
    id: Schema.Number,
    name: Schema.String.pipe(Schema.NullOr),
    createdAt: Schema.DateFromString,
    email: Schema.String,
    role: Schema.String,
    isBotUser: Schema.Boolean
}, {
    title: "User"
}) {
}
export class List extends Schema.Class("superwall-api-User-List")({
    object: Schema.Literal("list"),
    data: Schema.Array(Model),
    pagination: Pagination
}, {
    title: "UserList"
}) {
}
